const SINCE_BEGINNING_START = new Date(2021, 3, 26);

export const PRESET_MONTH_VALUES = [0.1, 0.25, 1, 3, 6, 12];

export const getPeriodPresets = (t) => [
  { id: "today", label: t("Today") },
  { id: "yesterday", label: t("Yesterday") },
  { id: "last7days", label: t("Last 7 days") },
  { id: "last30days", label: t("Last 30 days") },
  { id: "last3months", label: t("Last 3 months") },
  { id: "last6months", label: t("Last 6 months") },
  { id: "lastYear", label: t("Last year") },
  { id: "sinceBeginning", label: t("Since the beginning") },
];

export const getStartDateFromPreset = (presetId) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  switch (presetId) {
    case "today":
      return today;
    case "yesterday": {
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      return yesterday;
    }
    case "last7days": {
      const last7Days = new Date(today);
      last7Days.setDate(last7Days.getDate() - 7);
      return last7Days;
    }
    case "last30days": {
      const last30Days = new Date(today);
      last30Days.setDate(last30Days.getDate() - 30);
      return last30Days;
    }
    case "last3months": {
      const last3Months = new Date(today);
      last3Months.setMonth(last3Months.getMonth() - 3);
      return last3Months;
    }
    case "last6months": {
      const last6Months = new Date(today);
      last6Months.setMonth(last6Months.getMonth() - 6);
      return last6Months;
    }
    case "lastYear": {
      const lastYear = new Date(today);
      lastYear.setFullYear(lastYear.getFullYear() - 1);
      return lastYear;
    }
    case "sinceBeginning":
      return new Date(SINCE_BEGINNING_START.getTime());
    default:
      return null;
  }
};

export const getEndDateFromPreset = (presetId) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  today.setHours(23, 59, 59, 999);

  if (presetId === "yesterday") {
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(23, 59, 59, 999);
    return yesterday;
  }

  return today;
};

export const presetToMonths = (presetId) => {
  switch (presetId) {
    case "today":
    case "yesterday":
      return 0.1;
    case "last7days":
      return 0.25;
    case "last30days":
      return 1;
    case "last3months":
      return 3;
    case "last6months":
      return 6;
    case "lastYear":
      return 12;
    case "sinceBeginning":
      return null;
    default:
      return 6;
  }
};

export const monthsToPreset = (months) => {
  if (months === null || months === undefined) {
    return "sinceBeginning";
  }
  const numMonths = Number(months);
  if (isNaN(numMonths)) {
    return "last6months";
  }

  if (numMonths === 0.1 || (numMonths > 0 && numMonths < 0.2)) {
    return "today";
  }
  if (numMonths === 0.25 || (numMonths >= 0.2 && numMonths < 0.5)) {
    return "last7days";
  }
  if (numMonths === 1 || (numMonths >= 0.5 && numMonths < 2)) {
    return "last30days";
  }
  if (numMonths === 3 || (numMonths >= 2 && numMonths < 4.5)) {
    return "last3months";
  }
  if (numMonths === 6 || (numMonths >= 4.5 && numMonths < 9)) {
    return "last6months";
  }
  if (numMonths === 12 || (numMonths >= 9 && numMonths < 15)) {
    return "lastYear";
  }
  if (numMonths >= 15) {
    return "sinceBeginning";
  }
  return "last6months";
};
